module.exports = __webpack_public_path__ + "static/img/11.685fc02.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting584/images/11.png
// module id = WI9c
// module chunks = 4